/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { icons } from '../../../../../assets';
import { EOnboardingComponentsId } from '../../../../../modules/onboarding/types/onboardingTypes';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { openFooterWizardExpensesDetailAction } from '../../../../Table/actions/tableActions';
import { TTableButtonsGetTranslation } from '../useTableFooterButtons';

const useTableFooterButtonWizardExpensesDetail = (
    getTranslation: TTableButtonsGetTranslation,
) => {
    const dispatch = useDispatch();

    return {
        className: 'table-footer__button btn__wizard-expenses-detail',
        dataName: 'wizardExpensesDetail',
        icon: icons.payFriendSmall,
        id: AccessComponentKeyEnum.FooterButtonWizardExpensesDetail,
        onboarding: EOnboardingComponentsId.expensesAnalyzerAccountTableFooterButtonWizardExpensesDetail,
        ...getTranslation(AccessComponentKeyEnum.FooterButtonWizardExpensesDetail),

        onClick: useCallback(() => {
            dispatch(openFooterWizardExpensesDetailAction());
        }, [dispatch]),
    };
};

export default useTableFooterButtonWizardExpensesDetail;
